<template>
    <b-list-group>
        <b-list-group-item v-for="product in order" :class="{deleted: product.deleted}"
                           :key="product.id">
            <h5 class="mb-0"  v-b-toggle="'item-' + product.id">
              {{ brand }} - {{ product.name }} <span class="count">{{ product.count > 0 ? ` × ${product.count} шт` : '' }}</span>
            </h5>
            <b-collapse v-if="product.product.components"  :id="'item-' + product.id">
                <b-card  no-body v-for="description in JSON.parse(product.product.components)"
                         :key="description.title">
                    <p class="d-flex justify-content-center marginForP">{{description.title}} : {{description.weight}}</p>
                </b-card>
            </b-collapse>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
export default {
  name: 'CookOrderDetails',
  props: ['order', 'brand'],
  data: function () {
    return {

    }
  }
}
</script>

<style scoped>
    .marginForP {
        margin-bottom: 0;
    }
    .deleted {
        background: #F5C6CB;
        color: #fff;
    }
    .count {
      font-weight: 700;
      font-size: 16px;
      color: teal;
    }
</style>



// WEBPACK FOOTER //
// src/components/CookOrderDetails.vue